import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    card: {
      display: "flex",
      alignItems: "center",
      gap: "24px",
      padding: "20px",
      marginTop: "20px",
      width: "100%",
      boxSizing: "border-box",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "stretch",
        gap: "16px",
        width: "100%",
        minWidth: 0,
      },
    },
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      minWidth: 0,
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
        width: "100%",
        minWidth: 0,
      },
    },
    leftSection: {
      display: "flex",
      flexDirection: "column",
      minWidth: 140,
      [theme.breakpoints.down("xs")]: {
        alignItems: "flex-start",
        minWidth: "100%",
      },
    },
    typeText: {
      fontWeight: 700,
      fontSize: 18,
      color: theme.palette.text.primary,

      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
      },
    },
    saleInfo: {
      display: "flex",
      alignItems: "center",
      marginTop: 4,
      [theme.breakpoints.down("xs")]: {
        justifyContent: "center",
      },
    },
    saleText: {
      fontSize: 14,
      color: theme.palette.text.primary,
    },
    bedsText: {
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.text.primary,
    },
    middleSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      marginLeft: 4,
      [theme.breakpoints.down("xs")]: {
        alignItems: "flex-start",
        minWidth: "100%",
      },
    },
    medianSizeBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: 2,
    },
    medianText: {
      fontSize: 14,
      color: theme.palette.text.tertiary,
    },
    adsBox: {
      display: "flex",
      alignItems: "center",
      marginLeft: 4,
      [theme.breakpoints.down("xs")]: {
        justifyContent: "flex-start",
        marginLeft: 0,
        minWidth: "100%",
      },
    },
    adsText: {
      fontSize: 16,
      color: theme.palette.text.tertiary,
    },
    priceBox: {
      display: "flex",
      alignItems: "center",
      marginLeft: 4,
      [theme.breakpoints.down("xs")]: {
        justifyContent: "flex-start",
        marginLeft: 0,
        minWidth: "100%",
      },
    },
    priceText: {
      fontSize: 14,
      color: theme.palette.text.tertiary,
    },
  };
});
